var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " funnel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8772 17.4568L12.9032 18.9898V14.4368C12.9032 14.2708 12.9452 14.1078 13.0232 13.9618L17.3232 5.99976H6.64321L10.7652 13.9778C10.8392 14.1198 10.8772 14.2778 10.8772 14.4368V17.4568ZM13.9032 22C13.6902 22 13.4772 21.932 13.3002 21.797L9.27423 18.752C9.02423 18.563 8.87723 18.268 8.87723 17.955V14.681L4.11223 5.459C3.95123 5.149 3.96423 4.778 4.14623 4.48C4.32723 4.182 4.65123 4 5.00023 4H19.0002C19.3522 4 19.6782 4.185 19.8592 4.488C20.0392 4.79 20.0472 5.165 19.8802 5.475L14.9032 14.69V21C14.9032 21.379 14.6892 21.726 14.3492 21.895C14.2082 21.965 14.0552 22 13.9032 22Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.4b6ec97ae24fb06de8d5c6b198fb071c.svg";
export { ForwardRef as ReactComponent };